var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import MobileDetect from "mobile-detect";
import Button from "@irati/ui/src/Button";
import Loading from "@irati/ui/src/Loading";
import { FormattedMessage } from "@irati/utils/lang";
import { textMeInstructions } from "@irati/medical/services/medical";
import medicalTracking from "@irati-tracking/medical";
import { DeepLinkingUrls } from "@irati/medical/enums";
import isMobileDevice from "@irati/utils/mobile";
import SentText from "./SentText";
import LoadingWrapper from "./LoadingWrapper";
var TextMeInstructions = /** @class */ (function (_super) {
    __extends(TextMeInstructions, _super);
    function TextMeInstructions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null,
            isSent: false
        };
        _this.sendSMS = function () {
            var _a = _this.props, activationCode = _a.activationCode, trackingLocation = _a.trackingLocation;
            medicalTracking.textRequested(activationCode, trackingLocation);
            var load = textMeInstructions().then(function () {
                _this.setState({ isSent: true });
            });
            _this.setState({ load: load });
        };
        _this.openApp = function () {
            var _a = _this.props, activationCode = _a.activationCode, trackingLocation = _a.trackingLocation;
            var detect = new MobileDetect(window.navigator.userAgent);
            medicalTracking.launchApp(activationCode, trackingLocation);
            if (detect.os() === "iOS") {
                window.location.assign(DeepLinkingUrls.LINK_TO_STORE_PERKBOX_MEDICAL_IOS);
            }
            else {
                window.location.assign(DeepLinkingUrls.LINK_TO_STORE_PERKBOX_MEDICAL_ANDROID);
            }
        };
        return _this;
    }
    TextMeInstructions.prototype.render = function () {
        var _a = this.props, phoneNumber = _a.phoneNumber, isFull = _a.isFull;
        var _b = this.state, load = _b.load, isSent = _b.isSent;
        var lastThreeDigits = phoneNumber.substr(phoneNumber.length - 3);
        if (isMobileDevice()) {
            return React.createElement(Button, { primary: true, large: true, full: true, onClick: this.openApp },
                React.createElement(FormattedMessage, { id: "medical.global.buttons.openApp" }));
        }
        if (!phoneNumber) {
            return React.createElement(FormattedMessage, { id: "medical.textMeInstructions.noPhoneNumber" });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { load: load, primary: true, large: true, full: isFull, onClick: this.sendSMS },
                React.createElement(FormattedMessage, { id: "medical.global.buttons.instructions" })),
            isSent && React.createElement(SentText, { lastThreeDigits: lastThreeDigits }),
            React.createElement(LoadingWrapper, null,
                React.createElement(Loading, { load: load, useLoader: false }))));
    };
    TextMeInstructions.defaultProps = {
        isFull: false
    };
    return TextMeInstructions;
}(Component));
export default TextMeInstructions;
